import DatabaseLayout from '@/components/adminPage/DatabaseLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/database/')({
  component: DatabaseLayout,
})
